import { SVGProps } from 'react';

const TimerIcon = ({
  height = '24px',
  width = '24px',
  strokeWidth = '2',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 24 24'
    className='stroke-current'
    {...props}
  >
    <circle
      cx='8'
      cy='8'
      r='8'
      transform='translate(4 5.5)'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={strokeWidth}
    />
    <line
      x2='4'
      transform='translate(10 2.5)'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={strokeWidth}
    />
    <path
      d='M12,9v5l3,2'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={strokeWidth}
      fillRule='evenodd'
    />
  </svg>
);

export default TimerIcon;
